import { cloneElement } from 'react';
import * as colors from 'HubStyleTokens/colors';
import { UENameToIdMap } from '../../constants/unifiedEventTypeIds';
import ApprovalUnifiedEventSubmittedUserAvatar from './ApprovalUnifiedEventSubmittedUserAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const iconSize = 16;
export default function ApprovalUnifiedEventIcon(props) {
  const {
    event,
    defaultIcon
  } = props;
  const eventTypeId = event.eventTypeId.innerId;
  if (eventTypeId === UENameToIdMap.UE_APPROVAL_CREATED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (event.eventTypeId.innerId === UENameToIdMap.UE_APPROVAL_STEP_APPROVED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (event.eventTypeId.innerId === UENameToIdMap.UE_APPROVAL_CANCELED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (event.eventTypeId.innerId === UENameToIdMap.UE_APPROVAL_UPDATED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (event.eventTypeId.innerId === UENameToIdMap.UE_APPROVAL_REJECTED) {
    return /*#__PURE__*/_jsx(ApprovalUnifiedEventSubmittedUserAvatar, {
      event: event
    });
  }
  if (event.eventTypeId.innerId === UENameToIdMap.UE_APPROVAL_APPROVED) {
    return /*#__PURE__*/cloneElement(defaultIcon, {
      name: 'approvals',
      color: colors.EERIE,
      backgroundColor: colors.GREAT_WHITE,
      borderColor: colors.GREAT_WHITE,
      size: iconSize
    });
  }
  if (event.eventTypeId.innerId === UENameToIdMap.UE_APPROVAL_CONCLUDED) {
    return /*#__PURE__*/cloneElement(defaultIcon, {
      name: 'publish',
      color: colors.EERIE,
      backgroundColor: colors.GREAT_WHITE,
      borderColor: colors.GREAT_WHITE,
      size: iconSize
    });
  }
  return /*#__PURE__*/cloneElement(defaultIcon, {
    color: 'white',
    size: iconSize
  });
}